import React, { Component } from 'react';
import '../layout/loaders.css';

export default class Loading extends Component {

    render() {
        let style = {
            marginRight: this.props.right ? "20px" :"",
            marginLeft: this.props.left ? "20px" : ""
        };
        if(this.props.center) {
            style = {textAlign: "center"};
        }
        return this.props.loading ? (
            <div className={"loader-container" + (this.props.right ? " pull-right" : "")} style={style}>
                <div className="loader-inner ball-scale-multiple loader">
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        ) : (
            <div />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Loading.js